import React, { useMemo, useState } from 'react';
import Select from 'react-select';

import {
  CmBox,
  CmButton,
  CmFormControl,
  CmFormLabel,
  CmInput,
  CmLongLoading,
  CmSelect,
  MultipleReactSelectInput,
  useMultipleReactSelectInput,
} from '@/components/uiParts';
import { RoleType } from '@/domain/models/AuthEnterprise';
import { useInput } from '@/hooks/Form';
import { useAuthStores } from '@/services/Stores/hooks';

interface Props {
  onSubmit: (
    email: string,
    password: string,
    role_type: string,
    store_names: string[]
  ) => Promise<void>;
}

export const MemberInviteForm: React.VFC<Props> = ({ onSubmit }) => {
  const [name, nameProps] = useInput('', 'text');
  const [email, emailProps] = useInput('', 'email');
  const [selectedAuthority, setSelectedAuthority] =
    useState<RoleType>('管理者');

  const isSelectedStoreManager = useMemo(
    () => selectedAuthority === '店舗責任者',
    [selectedAuthority]
  );
  const { stores, isLoading } = useAuthStores(isSelectedStoreManager);

  const storeSelectInput: MultipleReactSelectInput =
    useMultipleReactSelectInput(stores.map((store) => store.store_name));

  const handleSelectAuthority: React.ChangeEventHandler<HTMLSelectElement> = (
    e
  ) => {
    const authName = e.target.value as RoleType;
    if (authName !== '店舗責任者') storeSelectInput.onReset();
    setSelectedAuthority(authName);
  };

  const storeNames = useMemo(
    () => storeSelectInput.value?.map((store) => store.value) || [],
    [storeSelectInput.value]
  );

  const isInvalid = useMemo(
    () => selectedAuthority === '店舗責任者' && storeNames.length === 0,
    [selectedAuthority, storeNames]
  );

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isInvalid) {
      alert('店舗を一つ以上選択してください');
      return;
    }
    await onSubmit(email, name, selectedAuthority, storeNames);
  };

  return (
    <CmBox as="form" onSubmit={handleSubmit}>
      <CmFormControl mb={6}>
        <CmFormLabel isRequired>名前</CmFormLabel>
        <CmInput bg="white" {...nameProps} isRequired />
      </CmFormControl>
      <CmFormControl mb={6}>
        <CmFormLabel isRequired>メールアドレス</CmFormLabel>
        <CmInput bg="white" {...emailProps} isRequired />
      </CmFormControl>
      <CmFormControl mb={6}>
        <CmFormLabel isRequired>権限</CmFormLabel>
        <CmSelect
          onChange={handleSelectAuthority}
          placeholder="選択してください"
          isRequired
          bg="white"
        >
          {RoleType.map((auth) => (
            <option key={auth} value={auth}>
              {auth}
            </option>
          ))}
        </CmSelect>
      </CmFormControl>
      {isSelectedStoreManager && (
        <CmFormControl mb={6}>
          <CmFormLabel isRequired>担当店舗</CmFormLabel>
          <Select
            isMulti
            {...storeSelectInput}
            placeholder="選択してください"
            isRequired
            bg="white"
          >
            {stores.map((store) => (
              <option
                key={`${store.id}-${store.store_name}`}
                value={store.store_name}
              >
                {store.store_name}
              </option>
            ))}
          </Select>
        </CmFormControl>
      )}
      {/*
       // @ts-ignore TS2590 */}
      <CmButton type="submit" width="100%" textAlign="center" my={5}>
        招待を送信
      </CmButton>
      {isLoading && <CmLongLoading />}
    </CmBox>
  );
};
